<!-- content begin -->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
<div id="content" class="no-bottom no-top">
  <div id="top"></div>

  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(assets/images/background/16.jpg) 0% 0px / cover">
    
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, 0.5)">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Job Registration</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-md-8 mx-auto">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <form
                  [formGroup]="profileForm"
                  (ngSubmit)="onSubmit()"
                  class="ng-untouched ng-pristine ng-invalid"
                >
                  <h1 style="color: #000; padding-bottom: 10px">
                    One Time Registration
                  </h1>
                  <!-- <p class="text-muted">Register In to your account</p> -->
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fa fa-envelope" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      formControlName="email"
                      placeholder="Valid email ID"
                      class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                      maxlength="50"
                    />
                    <div
                      *ngIf="submitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.required">
                        Email is required
                      </div>
                      <div *ngIf="f.email.errors.pattern">
                        Email must be a valid email address
                      </div>
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fa fa-mobile-phone" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      placeholder="Mobile Number"
                      formControlName="mobile"
                      autocomplete="mobile"
                      required=""
                      class="form-control ng-untouched ng-pristine ng-invalid"
                      [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }"
                      maxlength="10"
                    />
                    <div
                      *ngIf="submitted && f.password.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.mobile.errors.pattern">number only</div>
                      <div *ngIf="f.mobile.errors.required">
                        Mobile number is required
                      </div>
                      <div *ngIf="f.mobile.errors.minlength">
                        number must 10 digit
                      </div>
                    </div>
                  </div>

                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fa fa-lock" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      type="password"
                      formControlName="password"
                      placeholder="Password (Minimum 8 characters )"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid': submitted && f.password.errors
                      }"
                      maxlength="8"
                    />
                    <div
                      *ngIf="submitted && f.password.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.password.errors.required">
                        Password is required
                      </div>
                      <div *ngIf="f.password.errors.minlength">
                        Password must be at least 8 characters
                      </div>
                    </div>
                  </div>





                  <div class="row">
                    <div class="col-6">
                      <!-- <re-captcha (success)="handleSuccess($event)"
                     formControlName="recaptcha"></re-captcha> -->
                      <button
                        type="button"
                        type="submit"
                        class="btn cus-btn-primary px-4"
                      >
                        Register
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <style>
    .main.d-flex {
      background: #e4e5e6;
      /* height: 100vh; */
      padding: 60px 0px;
    }
    .cus-btn-primary {
      color: #fff;
      background-color: #20a8d8 !important;
      border-color: #20a8d8 !important;
    }
    .cus-btn-primary:hover,
    .btn_reg {
      color: #fff;
      background-color: #1b8eb7 !important;
      border-color: #1985ac !important;
    }
    .btn_reg:hover {
      background-color: #000;
    }
    h1,
    h2 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
    .btn-link {
      font-weight: 400;
      color: #20a8d8;
      text-decoration: none;
    }
  </style>
</div>
